/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Dry_Jay_DineInputs */

const en_happy_dry_jay_dine = /** @type {(inputs: Happy_Dry_Jay_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite result config`)
};

const de_happy_dry_jay_dine = /** @type {(inputs: Happy_Dry_Jay_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebniskonfiguration überschreiben`)
};

/**
* | output |
* | --- |
* | "Overwrite result config" |
*
* @param {Happy_Dry_Jay_DineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_dry_jay_dine = /** @type {((inputs?: Happy_Dry_Jay_DineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Dry_Jay_DineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_dry_jay_dine(inputs)
	return de_happy_dry_jay_dine(inputs)
});